import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import { Modal, Button } from "react-bootstrap";

export default function DocumentViewer({ clientId, clientName, show, onClose }) {
  const [loading, setLoading] = useState(false);
  const [docs, setDocs] = useState({
    existingDocs: [],
    additionalDocs: [],
    paymentChequeFiles: [],
  });
  const [errorModal, setErrorModal] = useState(false);
  const token = localStorage.getItem("accessToken");

  const DocCard = ({ title, href }) => (
    <div className="card shadow-sm" style={{ width: "14rem" }}>
      <div className="card-body">
        {/* <h6 className="card-title">{title}</h6> */}
        <a
          href={`https://${href}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          {title}
        </a>
      </div>
    </div>
  );

  // 📌 Fetch documents when modal opens
  useEffect(() => {
    if (!clientId || !show) return;
    fetchDocuments(clientId);
  }, [clientId, show]);

  const fetchDocuments = async (id) => {
    setLoading(true);

    try {
      const res = await api.get(`/client-onboard-docs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data.data || {};

      const existingDocs = Array.isArray(data.docs) ? data.docs : [];
      const additionalDocs = Array.isArray(data.additional_docs) ? data.additional_docs : [];

      // Normalize cheque files
      let paymentChequeFiles = [];
      if (Array.isArray(data.payment_cheque_files) && data.payment_cheque_files.length > 0) {
        const item = data.payment_cheque_files[0];
        if (item && item.cheque_files) {
          try {
            const parsed = JSON.parse(item.cheque_files);
            paymentChequeFiles = Array.isArray(parsed) ? parsed : [parsed];
          } catch {
            paymentChequeFiles = item.cheque_files.split(",").map((f) => f.trim());
          }
        }
      }

      setDocs({ existingDocs, additionalDocs, paymentChequeFiles });
    } catch (e) {
      console.error("Error loading documents:", e);
      setErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* 📌 Main Document Viewer Modal */}
      <Modal show={show} onHide={onClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{clientName || "Client Documents"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <p>Loading documents...</p>
          ) : (
            <>
              {/* Existing Docs */}
              {docs.existingDocs.map((doc, idx) => (
                <div key={idx}>
                  <h4 className="mt-3">Client Submitted Documents</h4>
                  <div className="d-flex flex-wrap gap-3 mb-2">
                    {doc.commercial_registration && (
                      <DocCard
                        title="Commercial Registration"
                        href={doc.commercial_registration}
                      />
                    )}
                    {doc.establishment_card && (
                      <DocCard title="Establishment Card" href={doc.establishment_card} />
                    )}
                    {doc.trade_licenses && (
                      <DocCard title="Trade Licenses" href={doc.trade_licenses} />
                    )}
                  </div>
                </div>
              ))}

              {/* Additional Docs */}
              {docs.additionalDocs.length > 0 && (
                <>
                  <h4 className="mt-3">Onboarding Files</h4>
                  <div className="d-flex flex-wrap gap-3 mb-2">
                    {docs.additionalDocs.map((file, idx) => (
                      <DocCard
                        key={idx}
                        title={file.file_type.replace(/_/g, " ")}
                        href={file.file_path}
                      />
                    ))}
                  </div>
                </>
              )}

              {/* Cheque Docs */}
              {docs.paymentChequeFiles.length > 0 && (
                <>
                  <h4 className="mt-3">Payment Related Files</h4>
                  <div className="d-flex flex-wrap gap-3 mb-2">
                    {docs.paymentChequeFiles.map((file, idx) => (
                      <DocCard key={idx} title="Cheque File" href={file} />
                    ))}
                  </div>
                </>
              )}

              {/* No Documents */}
              {docs.existingDocs.length === 0 &&
                docs.additionalDocs.length === 0 &&
                docs.paymentChequeFiles.length === 0 && (
                  <div className="alert alert-warning mt-3">No documents found.</div>
                )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Error Modal */}
      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>Failed to load documents. Please try again.</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setErrorModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}